import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { AuthProvider } from '@/features/auth/useAuth'
import { createQueryClient } from '@/lib/queryClient'
import { router } from '@/router'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element is missing from index.html.')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
